export default __webpack_public_path__ + "static/media/all-for-one-dark.5f26a204.svg";